<template>
  <div class="login py-3">
        <header class="mb-4">
            <div  class="div-cart">
                <h1><i class="fas fa-user"></i> Meu Perfil</h1>
            </div>
        </header>
        <div class="card">
            <div class="card-body">


                <div class="">
                    <table class="table">
                        <tr>
                            <td><strong>Nome: </strong></td>
                            <td>{{perfil.name}}</td>
                        </tr>
                        <tr>
                            <td><strong>Email: </strong></td>
                            <td>{{perfil.email}}</td>
                        </tr>
                        <tr>
                            <td><strong>Telefone: </strong></td>
                            <td>{{perfil.fone}}</td>
                        </tr>
                        <tr>
                            <td><strong>Endereço de Entrega Padrão: </strong></td>
                            <td>
                                <select name="endereco" class="form-control mb-2" id="" v-model="form.end_padrao">
                                    <option
                                        v-for="endereco in enderecos"
                                        :key="endereco.id"
                                        :value="endereco.id"
                                    >
                                        {{endereco.nome}}
                                    </option>
                                </select>
                                <a v-if="enderecos.length >0" @click="mudarEndPadrao()" class="btn b-btn mb-2 ml-1" role="button"><i class="fas fa-save"> </i>  Salvar</a>
                                <a v-else @click="modalEndereco()" class="btn b-btn " role="button"> Cadastrar novo endereço</a>
                            </td>
                        </tr>
                    </table>

                    <a @click="logout()" class="btn btn-dark" ><i class="fas fa-sign-out-alt"></i> Sair</a>
                </div>


            </div>
        </div>


    <div class="mb-4 mt-4">
        <h4>Meus Endereços:</h4>
    </div>

    <div v-if="!carregando">

        <div class="row" v-if="enderecos.length > 0">
            <div
                v-for="endereco in enderecos"
                :key="endereco.id"
                class="col-md-6 mb-4"
            >
                <div class="card-profile">
                    <div>
                        <h4>{{endereco.nome}}</h4>
                        <p>{{endereco.logradouro}}, {{endereco.numero}} </p>
                        <p><strong>Bairro:</strong> {{endereco.bairro_nome??''}} </p>
                        <p><strong>Complemento:</strong> {{endereco.complemento}}</p>
                        <p><strong>Ponto de Referência:</strong> {{endereco.referencia}} </p>
                        <p><strong>Cep:</strong> {{endereco.cep}} </p>
                        <br>
                    </div>
                    <!-- <div>
                        <button data-toggle="modal" data-target="#" class="btn btn-info" @click="modalEditEndereco(endereco)">Alterar endereço</button>

                        <button class="btn btn-danger" @click="excluirEndereco(endereco.id)" ><i class="fas fa-trash"></i> Excluir</button>
                    </div> -->

                </div>
            </div>
        </div>
        <div v-else class="text-center my-5">
            <div class="card">
                <p class="text-center my-3">Nenhum Endereço Cadastrado</p>
            </div>
        </div>


    </div>
    <div v-else class="text-center">
        <div class="spinner-border text-info my-5" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>

     <!-- <a @click="modalEndereco()" class="btn b-btn " role="button"> Cadastrar novo endereço</a> -->




  </div>
</template>

<script>
import api from "../service/api";
import Cookie from "js-cookie";
export default {

    data () {
    return {
        enderecos: [],
        carregando:false,

        form: new Form({
            end_padrao : '',
        }),


    }
  },

    methods: {

        async carregarEnderecos(){
          this.carregando = true;
          await api
          .get('/login-user/enderecos')
          .then(response => (this.enderecos = response.data));
          this.$store.dispatch('fetchPerfil').then();
          this.carregarEnderecoPadrao();
          this.carregando = false;
        },

        carregarEnderecoPadrao(){
            let obj1 = JSON.parse(JSON.stringify(this.perfil.endereco_padrao_id));

            this.form.end_padrao = obj1
        },

        async mudarEndPadrao() {
            await api
            .put('/login-user/endereco-padrao/'+this.form.end_padrao)
            .then((response) => {

                Swal.fire({
                    icon: 'success',
                    title: 'Endereço Padrão alterado com Sucesso',
                    showConfirmButton: false,
                    timer: 1500
                });
                this.$store.dispatch('fetchPerfil').then();
            });
        },

        excluirEndereco(id){
            Swal.fire({
                title: 'Tem certeza que deseja excluir esse endereço?',
                text: "Você não poderá reverter isso!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Sim, pode excluir!'
            }).then((result) => {

                // Send request to the server
                if (result.value) {
                    api.delete('/endereco/'+id).then(()=>{
                            Swal.fire(
                            'Deletado!',
                            'Seu Endereço foi excluído.',
                            'success'
                            );
                        this.$store.dispatch('fetchPerfil').then();
                        this.carregarEnderecos();
                    }).catch((data)=> {
                        Swal.fire("Failed!", data.message, "warning");
                    });
                }
            })
        },


        logout(){
            this.$store.dispatch('logoutPerfil').then();
            this.$router.push("/site");
        },

        async modalEndereco(){
            Cookie.set('proximaPagina', 'perfil' );
            this.$store.dispatch('removerEnderecoAtivo').then();
            await this.$store.dispatch('showModalEndereco').then();
            $('#modalEndereco').modal('show');
        },

        async modalEditEndereco(endereco){
            Cookie.set('proximaPagina', 'perfil' );
            let obj1 = JSON.parse(JSON.stringify(endereco));
            await this.$store.dispatch('showModalEndereco').then();
            await this.$store.dispatch('atualizarEnderecoAtivo', obj1).then();
            $('#modalEndereco').modal('show');
        },

    },

    computed: {

        perfil() {

          return this.$store.state.perfil.main;
        },
    },

    created () {
        this.carregarEnderecos();
    },

}
</script>

<style>


.login .card{
    box-shadow: 2px 2px 4px 0px #a7a7a7;
    border-radius: 10px;
}

.login .card form .row {
    margin: 20px 0;
}

.login .card form .pass {
    font-size: 0.8rem;
}

.login li {
    list-style-type: none;
}

.login .card-profile{
    padding: 10px;
    background-color: #ffffff;
    box-shadow: 2px 2px 4px 0px #a7a7a7;
    border-radius: 10px;
}

.login .card-profile:hover{
    box-shadow: 2px 2px 8px 0px #a7a7a7;
}

.login .card-profile p{
    margin-bottom: 0;
}



</style>
